import React, { useContext, useState, useEffect } from "react";
import styled from 'styled-components';
import ChatGlobalContext from "../context/ChatGlobalContext";
import icoChat from '../assets/images/chat.svg';
import icoCloseChat from '../assets/images/ico-close.png';
import WidgetButton from "./styled/WidgetButton";

const Widget = ({...props}) => {
    const gContext: any = useContext(ChatGlobalContext);

    const [openChat, setOpenChat] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
  
    useEffect(() => {
        setOpenChat(gContext?.goGetTwilioChat()?.openChat);
    }, [gContext?.goGetTwilioChat()?.openChat]);
  
    useEffect(() => {
        setFullscreen(gContext?.goGetTwilioChat()?.fullscreen);
    }, [gContext?.goGetTwilioChat()?.fullscreen]);
          
    const chatToggle = () => {
        gContext?.goGetTwilioChat()?.chatClosing && gContext?.goResetTwilioChat();
        let tmpState = {...gContext?.goGetTwilioChat(), openChat: !gContext?.goGetTwilioChat()?.openChat, outage: !gContext?.goGetTwilioChat()?.outage, question: !gContext?.goGetTwilioChat()?.question};
        if(!gContext?.goGetTwilioChat()?.openChat && gContext?.goGetTwilioChat()?.chatUnreaded) tmpState = {...tmpState, chatUnreaded: false};
        gContext?.goGetTwilioChat()?.messages && gContext?.goSetTwilioChat(tmpState);
    };

    return (
        <WidgetButton onClick={() => chatToggle()} className={`YFChat ${openChat ? 'open' : ''} ${fullscreen?'fullscreen':''}`}>
          <img src={icoChat} className='icon-default' />
          <img src={icoCloseChat} className='icon-hover' />
          {gContext?.goGetTwilioChat()?.chatUnreaded && <small className='unread'>1</small>}
        </WidgetButton>
    );
};

export default Widget;